/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCollageFill: {
  name: 'collage-fill';
  data: string;
} = {
  name: 'collage-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1A.5.5 0 0 1 1 .5h6a.5.5 0 0 1 .5.5v14a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5V1ZM9 .5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V1a.5.5 0 0 0-.5-.5H9Zm0 8a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5H9Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
